<template>
  <div class="certDetail">
    <pageTitle class="getHeader" :title="title"></pageTitle>
    <div class="proBox" :class="{'preventClick': preventClick}">
      <!-- 选择企业 Strart -->
      <chooseEnt @getEntId="getEntId" :showEntId="entId" :showEntName="entName"/>
      <!-- 选择企业 End -->

      <!-- 选择产品 Strart -->
      <choosePro ref="choosePro" @getProductId="getProductId" :showEntId="entId"
                 :showProductId="productId"
                 :showProductName="productName"/>
      <!-- 选择产品 End -->

      <div class="form-group">
        <label class="van-col--8">
          打印数量
          <span class="imp">*</span>
        </label>
        <div class="van-col--14">
          <input v-model="form.printCount" type="number" pattern="[0-9]*" minlength="1"
                 placeholder="请填写打印数量"/>
        </div>
      </div>
      <div class="form-group">
        <label class="van-col--8">
          产品数量
          <span class="imp">*</span>
        </label>
        <div class="van-col--14">
          <input v-model="form.num" type="number" minlength="1" placeholder="请填写产品数量"/>
        </div>
      </div>
      <div class="form-group white">
        <label class="van-col--8">
          产品单位
          <span class="imp">*</span>
        </label>
        <div class="van-col--14">
          <input v-model="form.unitName" @click="unitShow=true" readonly
                 placeholder="请选择产品单位"/>
        </div>
      </div>
      <div class="form-group white">
        <label class="van-col--8">
          生产日期：
          <span class="imp">*</span>
        </label>
        <div class="van-col--14">
          <input v-model="form.printTime" placeholder="请选择生产日期" readonly
                 @click="timeShow=true"/>
        </div>
      </div>
      <div class="form-group white">
        <label class="van-col--8">
          二维码地址
          <span class="imp">*</span>
        </label>
        <div class="van-col--12">
          <input v-model="form.extUrl" placeholder="扫描二维码识别地址"/>
        </div>
        <div class="van-col--4">
          <button class="toScan" type="button" @click="toScanCode">扫描</button>
        </div>
      </div>
      <Camera title="拍摄二维码照片" :showList="imgUpList" @uploadPicList="uploadPicList"
              @deletePicList="deletePicList"/>
      <div v-if="showSign">
        <p class="line-title">签名:</p>
        <div class="sign-form">
          <Sign :signature="form.signature" @setSignUrl="setSignUrl"/>
        </div>
      </div>
      <div class="submit" v-if="!preventClick">
        <van-button round type="primary" @click="submit">提交合格证</van-button>
        <van-button v-if="certificatePaperId" round type="danger" @click="delOne">删除合格证
        </van-button>
      </div>
    </div>
    <!-- 选择时间 -->
    <van-popup v-model="timeShow" position="bottom">
      <van-datetime-picker
                           v-model="currentDate"
                           type="date"
                           :max-date="maxDate"
                           @confirm="timeConfirm"
                           @cancel="timeShow=false"
      />
    </van-popup>
    <!-- 选择单位 -->
    <van-popup v-model="unitShow" position="bottom">
      <van-picker
                  show-toolbar
                  :columns="unitList"
                  @confirm="unitConfirm"
                  @cancel="unitShow=false"/>
    </van-popup>
  </div>
</template>

<script>
import { getUnitList } from '@/api/dictionary'
import {
  delCertificatePaper,
  editCertificatePaper,
  getOneCertificatePaper,
  saveCertificatePaper,
} from '@/api/paper'
import { formatterDay } from '@/utils/publicFun'
import chooseEnt from '@/components/common/chooseEnt/chooseEnt'
import choosePro from '@/components/common/chooseProduct/chooseProduct'
import Camera from '@/components/Camera/Camera'
import Sign from '@/components/Sign/Sign'
import { printAreaCode } from '@/utils/baseUrl'
// import jsQR from 'jsqr'

export default {
  name: 'paper-detail-sx',
  components: {
    chooseEnt,
    choosePro,
    Sign,
    Camera,
  },
  data () {
    return {
      title: '纸质合格证详情',
      certificatePaperId: '',
      showEntPro: false,
      form: {
        printCount: '',
        num: '',
        unitId: '',
        unitName: '',
        printTime: '',
        signature: '',
        extUrl: '',
      },
      showSign: false,
      unitShow: false,
      unitList: [],
      timeShow: false,
      currentDate: new Date(),
      maxDate: new Date(),
      productName: '',
      productId: '',
      pageNum: 1,
      pageSize: 20,
      total: 0,
      loading: false,
      finished: false,
      productList: [],
      productShow: false,
      entId: '',
      entName: '',
      preventClick: false,
      imgUpList: [],
    }
  },
  created () {
    if (printAreaCode === '50') {
      this.title = '追溯信息详情'
    } else {
      this.title = '纸质合格证详情'
    }

    // 获取计量单位
    this.toGetUnitList()
    // 获取详情
    const certificatePaperId = this.$route.query.certificatePaperId || ''
    this.certificatePaperId = certificatePaperId
    if (certificatePaperId) {
      this.toGetOneCertificateRecord(certificatePaperId)
    } else { // 新增时获取时间
      this.showSign = true
      this.form.printTime = formatterDay()
    }
  },
  mounted () {
    // if (!this.$checkUserType()) {  // 企业端 和 游客
    //   this.getPageEnterpriseProduct()
    // }
  },
  methods: {
    getEntId (data) { // 获取企业Id
      this.entId && this.$refs.choosePro.onProductSearch()
      this.entId = data.entId || ''
      this.entName = data.entName || ''
      this.productId = ''
      this.productName = ''
    },
    toGetOneCertificateRecord (id) { // 获取一个详情
      getOneCertificatePaper({
        certificatePaperId: id,
      }).then(res => {
        if (res.state === 'Y') {
          if (res.data.printNum > 0) {
            this.preventClick = true
          }

          this.form.extUrl = res.data.extUrl || '';
          this.form = res.data

          this.showSign = !!res.data.signature
          this.entId = res.data.entId
          this.entName = res.data.entName
          this.productId = res.data.entProductId
          this.productName = res.data.productName
          this.imgUpList = res.data.dataUrl && [{ src: res.data.dataUrl }]
        } else {
          this.$alertErr(res.msg)
        }
      }).catch(err => {
        this.$alertErr(err || '网络错误，请稍后再试！')
      })
    },
    showProductList () { // 打开产品列表
      if (this.$checkUserType()) { // 管理员 和 监管用户
        if (!this.entId) {
          this.$toast('请先选择企业！')
          return
        }
      }
      this.productShow = true
    },
    getProductId (obj) { // 选择产品
      this.productName = obj.productName
      this.productId = obj.productId
    },
    timeConfirm (data) { // 时间选择
      this.form.printTime = formatterDay(data)
      this.timeShow = false
    },
    unitConfirm (obj) { // 单位选择
      this.form.unitId = obj.value
      this.form.unitName = obj.text
      this.unitShow = false
    },
    toGetUnitList () { // 计量单位
      getUnitList().then(res => {
        if (res.state === 'Y') {
          this.unitList = res.data.map(v => {
            return { text: v.unitName, value: v.unitId }
          })
        } else {
          this.$alertErr(res.msg)
        }
      }).catch(err => {
        this.$alertErr(err || '网络错误，请稍后再试！')
      })
    },
    setSignUrl (url) { // 签名
      this.form.signature = url
    },
    delOne () {// 删除一个产品
      this.$dialog.confirm({
        title: '确认删除？',
        message: '',
      }).then(() => {
        let toa = this.$toast
        toa.loading({
          mask: true,
          message: '删除中...',
        })
        delCertificatePaper({
          certificatePaperId: this.certificatePaperId,
        })
            .then((res) => {
              if (res.state === 'Y') { // 删除产品
                this.$toast.success('删除成功')
                setTimeout(() => {
                  this.$router.go(-1)
                }, 2000)
              } else {
                this.$toast(res.msg)
                return false
              }
            })
            .catch((err) => {
              this.$toast('网络错误，稍后再试！')
              return false
            })
        // on confirm
      }).catch(() => {
        // on cancel
      })
    },
    uploadPicList (list) { // 上传回调
      list.forEach(s => {
        this.imgUpList.push({ src: s.src })
      })
    },
    deletePicList (index) { // 删除回调
      this.imgUpList.splice(index, 1)
    },
    /**
     * 获取图片base64
     * @param {string} url 图片路径
     * @param {(base64: string) => void} callback 回调
     * @param {'jpg'|'png'} type 图片格式（可选）
     */
    getBase64 (url, callback, type = 'jpg') {
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      const img = new Image()
      img.crossOrigin = 'Anonymous'
      img.src = url
      img.onload = function () {
        canvas.width = img.width
        canvas.height = img.height
        ctx.drawImage(img, 0, 0)
        var imageData = ctx.getImageData(0, 0, img.width, img.height);
        const base64 = canvas.toDataURL('image/' + type)
        if (typeof callback === 'function') callback(imageData.data, imageData.width, imageData.height)
      }
    },
    toScanCode () { // 扫码
      var _this = this
      window.getQRCodeUrl = function (url) {
        if (!url) {
          _this.$toast('未识别到二维码！')
          return
        }
        _this.form.extUrl = url;
      }
      // 原生
      let u = navigator.userAgent
      if (!!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
        /* eslint-disable no-undef */
        window.webkit.messageHandlers.scanCode.postMessage(null)
      } else if (u.indexOf('Android') > -1 || u.indexOf('Adr') > -1) {
        /* eslint-disable no-undef */
        method.scanCode()
      } else {
        // 不在 移动端
        this.$toast('请使用App扫码！')
      }
    },
    // toScan () { // 识别
    //   const imgUrl = this.imgUpList[0] && this.imgUpList[0].src
    //   if (!imgUrl) {
    //     this.$alertErr('请先上传二维码图片！')
    //     return
    //   }
    //   this.getBase64(imgUrl, (imageData, width, height) => {
    //     const code = jsQR(imageData, width, height, {
    //       inversionAttempts: "dontInvert",
    //     });
    //     if(code && code.data) {
    //       this.form.extUrl = code.data;
    //     } else {
    //       this.$alertErr('识别不了图片二维码！');
    //     }
    //   });
    // },
    chooseWay (obj) {
      if (obj.certificatePaperId) {
        return editCertificatePaper(obj)
      } else {
        return saveCertificatePaper(obj)
      }
    },
    submit () {
      const { num, unitId, printTime, signature, printCount, extUrl } = this.form
      const entId = this.entId || ''
      const productId = this.productId || ''
      let imageList = this.imgUpList
      let dataUrl = imageList[0] && imageList[0].src || ''

      if (this.$checkUserType()) { // 管理员 和 监管用户
        if (!this.entId) {
          this.$toast('请选择企业！')
          return false
        }
      }
      if (!productId) {
        this.$toast('请选择产品名称!')
        return false
      }
      if (!printCount) {
        this.$toast('请选择打印数量!')
        return false
      }
      if (!num) {
        this.$toast('请填写产品数量!')
        return false
      }
      if (!unitId) {
        this.$toast('请选择产品单位!')
        return false
      }
      if (!printTime) {
        this.$toast('请选择生产日期!')
        return false
      }
      // if (!dataUrl) {
      //   this.$toast('请拍照!')
      //   return false
      // }
      if (printAreaCode === '50' &&!extUrl) {
        this.$toast('请扫描二维码!')
        return false
      }
      this.$dialog.confirm({
        title: '确认提交？',
        message: '',
      }).then(() => {
        let toa = this.$toast
        toa.loading({
          mask: true,
          message: '上传中...',
        })
        let dataBag = {
          entProductId: productId,
          num,
          unitId,
          printTime,
          signature,
          printCount,
          entId: entId,
          dataUrl: dataUrl,
        }

        if (printAreaCode === '50') { // 重庆识别二维码
          dataBag.extUrl = extUrl;
        }

        if (this.certificatePaperId) { // 修改需要id
          dataBag.certificatePaperId = this.certificatePaperId
        }
        this.chooseWay(dataBag)
            .then((res) => {
              if (res.state === 'Y') { // 添加合格证
                this.$toast.success('提交成功')
                setTimeout(() => {
                  this.$router.go(-1)
                }, 2000)
              } else {
                this.$toast(res.msg)
                return false
              }
            })
            .catch((err) => {
              this.$toast('网络错误，稍后再试！')
              return false
            })
        // on confirm
      }).catch(() => {
        // on cancel
      })
    },
  },
}
</script>

<style lang="stylus" scoped>
.certDetail {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;


  & > .proBox {
    flex: 1;
    display: flex;
    flex-direction: column;

    p {
      height: 40px;
      background: #fff;
      line-height: 40px;
      display: flex;
      border-bottom: 1px solid #ddd;
      margin-bottom: 10px;

      a {
        flex: 1;
      }

      a.router-link-exact-active {
        color: #2AB774;
      }
    }
  }

  p.line-title {
    padding: 0 6vmin;
    height: 9vmin;
    line-height: 9vmin;
    font-size: 4vmin;
    font-weight: 600;
    color: #5d5d5d;
    background: #fff;
    position: relative;
    margin: 0;

    &:before {
      content: "";
      position: absolute;
      left: 2vmin;
      top: 2vmin;
      height: 5vmin;
      width: 1.5vmin;
      background: #2AB774;
    }
  }

  .sign-form {
    background: #fff;
    padding: 20px;
    display: block;
    height: 40vmin;
  }

  .submit {
    text-align: center;
  }

  .toScan {
    height: 30px;
    line-height: 30px;
    padding: 0 10px;
    color: #fff;
    background: #48d68a;
    border: 0;
    border-radius 4px;
  }

  .switch {
    vertical-align: middle;
    height: 6vw;
    width: 16vw;
    border-radius: 3vw;
    margin-left: 2vw;

    /deep/ .van-switch__node {
      height: 5.9vw;
      width: 5.9vw;
      transform: translateX(.1vw)
    }

    /deep/ &.van-switch--on {
      .van-switch__node {
        transform: translateX(10vw)
      }
    }
  }

}

</style>
